"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Component = _interopRequireDefault(require("../Component"));

var _Input = _interopRequireDefault(require("../Input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formatter = _interopRequireDefault(require("./utils/formatter"));

var _cursorPosition = _interopRequireDefault(require("../../utils/cursorPosition"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NumberInput = _react["default"].forwardRef(function (_ref, ref) {
  var Component = _ref.component,
      elementRef = _ref.elementRef,
      onChange = _ref.onChange,
      value = _ref.value,
      stringify = _ref.stringify,
      fractionSeparator = _ref.fractionSeparator,
      fractionLength = _ref.fractionLength,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["component", "elementRef", "onChange", "value", "stringify", "fractionSeparator", "fractionLength"]);
  var input = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      changed = _useState2[0],
      setChanged = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      cursor = _useState4[0],
      setCursor = _useState4[1];

  var formatter = typeof stringify === 'function' ? stringify : _formatter["default"];
  var handleChange = (0, _react.useCallback)(function (event) {
    if (typeof onChange === 'function') {
      var _value = event.target.value;

      var _cursor = (0, _slicedToArray2["default"])(cursor, 1),
          update = _cursor[0];

      var target = {
        name: event.target.name,
        focus: event.target.focus,
        type: event.target.type,
        value: formatter(_value, fractionSeparator, fractionLength)
      };

      if (update) {
        update(event);
      } // возвращаем форматированное значение, потому что при записи в модель
      // незаконченный ввод будет обрезан пример: 11.


      onChange(_objectSpread({}, event, {
        target: target,
        currentTarget: target
      }));
      setChanged(true);
    }
  }, [onChange, cursor]);
  var formattedValue = (0, _react.useMemo)(function () {
    return formatter(value, fractionSeparator, fractionLength);
  }, [value]);
  (0, _react.useEffect)(function () {
    if (input.current) {
      setCursor((0, _cursorPosition["default"])(input, /[\d,.-]/));
    }
  }, [input === null || input === void 0 ? void 0 : input.current]); // add refs

  (0, _react.useEffect)(function () {
    if (ref) {
      ref.current = input.current;
    }

    if (typeof elementRef === 'function') {
      elementRef(input.current);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = input.current;
    }

    return function () {
      if (ref) {
        ref.current = null;
      }

      if (typeof elementRef === 'function') {
        elementRef(null);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = null;
      }
    };
  }, [ref, elementRef]);
  (0, _react.useEffect)(function () {
    if (changed) {
      var _cursor2 = (0, _slicedToArray2["default"])(cursor, 2),
          update = _cursor2[0],
          set = _cursor2[1];

      if (set) {
        set(value);
      }

      setChanged(false);
    }
  }, [value]);
  return _react["default"].createElement(Component, (0, _extends2["default"])({}, rest, {
    onChange: handleChange,
    value: formattedValue,
    ref: input
  }));
});

NumberInput.defaultProps = {
  placeholder: '200.00',
  maxLength: 9,
  floating: false,
  type: 'text',
  fractionLength: 2,
  fractionSeparator: [',', '.'],
  component: _Input["default"],
  inputMode: 'decimal'
};
NumberInput.propTypes = {
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,

  /**
   * 9 999 999 by default 9 digits with spaces
   */
  maxLength: _propTypes["default"].number,
  floating: _propTypes["default"].bool,
  stringify: _propTypes["default"].func,
  value: _propTypes["default"].any,
  fractionLength: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  fractionSeparator: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = NumberInput;
exports["default"] = _default;